import React from 'react'
import { IconProps } from './icons.types'

export const Sparkles: React.FC<IconProps> = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1648 5.65189C10.1927 10.1575 13.844 13.8015 18.3447 13.8032C13.8277 13.8048 10.1663 17.4753 10.1646 22.0034C10.163 17.4804 6.50991 13.8131 2 13.8032C6.49362 13.7932 10.1369 10.1523 10.1648 5.65189Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.996 2C19.0062 3.65328 20.346 4.99041 21.9975 4.99101C20.34 4.99162 18.9965 6.33845 18.9959 8C18.9953 6.34034 17.6549 4.99468 16 4.99102C17.6489 4.98737 18.9858 3.65139 18.996 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
